"use client";

import { c as _c } from "react/compiler-runtime";
import { CopyableContent } from "@/src/components/copyable-content";
import { getFormattedAddress } from "@/src/models/address";
import { Referral } from "@/src/models/documents/referral";
import { getPractitionerNameWithCredentials } from "@/src/models/practitioner";
interface ReferringProviderSectionProps {
  referral: Referral;
  title?: string;
}
export function ReferringProviderSection(t0) {
  const $ = _c(22);
  const {
    referral,
    title: t1
  } = t0;
  const title = t1 === undefined ? "Referring Provider Information:" : t1;
  let t2;
  if ($[0] !== referral.referringProvider) {
    t2 = referral.referringProvider ? getPractitionerNameWithCredentials(referral.referringProvider) : "N/A";
    $[0] = referral.referringProvider;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const referringProviderName = t2;
  const referringProviderNPI = referral.referringProvider?.npiNumber || "N/A";
  let t3;
  if ($[2] !== referral.referringLocation) {
    t3 = referral.referringLocation?.address ? getFormattedAddress(referral.referringLocation.address) || "N/A" : "N/A";
    $[2] = referral.referringLocation;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const referringLocationAddress = t3;
  let t4;
  if ($[4] !== title) {
    t4 = <h3 className="font-semibold text-foreground my-2">{title}</h3>;
    $[4] = title;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="font-medium">Name: </span>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== referringProviderName) {
    t6 = <div>{t5}<CopyableContent text={referringProviderName} /></div>;
    $[7] = referringProviderName;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="font-medium">NPI: </span>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== referringProviderNPI) {
    t8 = <div>{t7}<CopyableContent text={referringProviderNPI} /></div>;
    $[10] = referringProviderNPI;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="font-medium">Referring Location: </span>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== referringLocationAddress) {
    t10 = <div>{t9}<CopyableContent text={referringLocationAddress} /></div>;
    $[13] = referringLocationAddress;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t6 || $[17] !== t8) {
    t11 = <div className="grid grid-cols-3">{t6}{t8}{t10}</div>;
    $[15] = t10;
    $[16] = t6;
    $[17] = t8;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t4) {
    t12 = <div className="mb-4 my-2">{t4}{t11}</div>;
    $[19] = t11;
    $[20] = t4;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
}